import { MsalProvider } from '@azure/msal-react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { AuthProvider } from './auth/AuthProvider'
import { AUTH_MODE } from './auth/config'
import { createMsalInstance } from './auth/msal'
import './styles/app.css'

async function bootstrap() {
  const container = document.getElementById('root')
  if (!container) throw new Error('Root element is missing from index.html')
  const root = createRoot(container)

  if (AUTH_MODE !== 'entra') {
    root.render(
      <StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </StrictMode>,
    )
    return
  }

  // MSAL must finish initialising and settle any redirect before first render.
  const instance = await createMsalInstance()
  root.render(
    <StrictMode>
      <MsalProvider instance={instance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </StrictMode>,
  )
}

void bootstrap()
